import { render, staticRenderFns } from "./parcel-list.vue?vue&type=template&id=4393669c"
import script from "./parcel-list.vue?vue&type=script&lang=ts"
export * from "./parcel-list.vue?vue&type=script&lang=ts"
import style0 from "./parcel-list.vue?vue&type=style&index=0&id=4393669c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports